
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/bird",
      function () {
        return require("private-next-pages/destinations/bird.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/bird"])
      });
    }
  